import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

import EquipmentMasterCatalogApi from "../../../../../infrastructure/api/equipmentMasterCatalog";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";

const empty = {
  id: 0,
  code: "",
  titleFa: "",
  titleEn: "",
  codePrefix: "",
  sortOrder: 0,
  isActive: true,
};

const EquipmentCategoryManagement = () => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);

  const load = () =>
    EquipmentMasterCatalogApi.getCategories(true).then((r) => setRows(r?.data || []));

  useEffect(() => {
    load();
  }, []);

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const openNew = () => {
    setForm(empty);
    setOpen(true);
  };
  const openEdit = (row) => {
    setForm({ ...empty, ...row });
    setOpen(true);
  };

  const save = async () => {
    if (!/^[A-Z]{3}$/.test(form.codePrefix || "")) {
      return toast.warn("پیشوند کد باید دقیقاً سه حرف بزرگ انگلیسی باشد.");
    }
    const payload = { ...form, sortOrder: Number(form.sortOrder) || 0 };
    const res =
      form.id > 0
        ? await EquipmentMasterCatalogApi.updateCategory(payload)
        : await EquipmentMasterCatalogApi.createCategory(payload);
    if (res.ok) {
      toast.success("ذخیره شد");
      setOpen(false);
      load();
    } else toast.error(res.message || "خطا");
  };

  const headCells = [
    { id: "codePrefix", label: "پیشوند" },
    { id: "code", label: "کد" },
    { id: "titleFa", label: "عنوان فارسی" },
    { id: "sortOrder", label: "ترتیب" },
    { id: "isActive", label: "فعال", type: "boolean" },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <BreadcrumbsComponent />
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title="دسته‌های تجهیزات"
            action={
              <Button variant="contained" startIcon={<AddIcon />} onClick={openNew}>
                ایجاد دسته
              </Button>
            }
          />
          <CardContent>
            <EnhancedTable
              rowKey={"id"}
              rows={rows}
              headCells={headCells}
              pageSize={100}
              actions={[
                {
                  icon: <EditIcon sx={{ width: "1rem", height: "1rem" }} />,
                  onClick: openEdit,
                  color: "primary",
                  tooltip: "ویرایش",
                },
              ]}
            />
          </CardContent>
        </Card>
      </Grid>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>{form.id > 0 ? "ویرایش دسته" : "ایجاد دسته"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                label="پیشوند کد (سه حرف بزرگ)"
                value={form.codePrefix}
                inputProps={{ maxLength: 3, style: { textTransform: "uppercase" } }}
                onChange={(e) => setField("codePrefix", e.target.value.toUpperCase())}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                label="کد داخلی"
                value={form.code}
                onChange={(e) => setField("code", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                label="عنوان فارسی"
                value={form.titleFa}
                onChange={(e) => setField("titleFa", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                label="عنوان انگلیسی"
                value={form.titleEn}
                onChange={(e) => setField("titleEn", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                type="number"
                label="ترتیب نمایش"
                value={form.sortOrder}
                onChange={(e) => setField("sortOrder", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={!!form.isActive}
                    onChange={(e) => setField("isActive", e.target.checked)}
                  />
                }
                label="فعال"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>انصراف</Button>
          <Button variant="contained" onClick={save}>
            ذخیره
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default EquipmentCategoryManagement;
